import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface OtherDataStore {
	otherData: boolean;
	googleData: boolean;
	videoAnalyticsData: boolean;
	setOtherData: (value: boolean) => void;
	setGoogleData: (value: boolean) => void;
	setVideoAnalyticsData: (value: boolean) => void;
}

const useOtherDataStore = create<OtherDataStore>()(
	devtools((set) => ({
		otherData: false,
		googleData: false,
		videoAnalyticsData: false,
		setOtherData: (value) => set(() => ({ otherData: value })),
		setGoogleData: (value) => set(() => ({ googleData: value })),
		setVideoAnalyticsData: (value) => set(() => ({ videoAnalyticsData: value })),
	})),
);

export default useOtherDataStore;
